import React, { useState } from 'react';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';
import Button from '../../../components/Atoms/buttons/button';
import { MdOutlineClose } from 'react-icons/md';
import { alertActions, paymentMethodActions } from '../../../_actions';
import Loader from '../../../components/Atoms/Loader';
import { useDispatch } from 'react-redux';
import Nodata from '../../../components/Atoms/NoData/NoData';
import { BiErrorCircle } from 'react-icons/bi';



const StarRating = ({ rating, setRating, editable = false, error = false }) => {
    return (
        <div className="flex">
            {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return editable ? (
                    <button
                        key={index}
                        onClick={() => setRating(starValue)}
                        className={`focus:outline-none ${error ? 'animate-pulse' : ''}`}
                    >
                        {starValue <= rating ? (
                            <AiFillStar className={`text-xl ${error ? 'text-red-400' : 'text-yellow-400'}`} />
                        ) : (
                            <AiOutlineStar className={`text-xl ${error ? 'text-red-400' : 'text-gray-400'}`} />
                        )}
                    </button>
                ) : (
                    <span key={index}>
                        {starValue <= rating ? (
                            <AiFillStar className="text-yellow-400 text-sm" />
                        ) : (
                            <AiOutlineStar className="text-gray-400 text-sm" />
                        )}
                    </span>
                );
            })}
            {rating > 0 && editable && <span className="ml-2 text-sm text-gray-600">{rating}/5</span>}
        </div>
    );
};


const ReviewModal = ({ isOpen, onClose, modalType = 'view', storData, reviewData }) => {
    const dispatch = useDispatch()
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [charCount, setCharCount] = useState(0);
    const maxChars = 300;
    const [isLoading, setIsLoading] = useState(false)
    const [ratingError, setRatingError] = useState('');
    const [commentError, setCommentError] = useState('');

    if (!isOpen) return null;

    const validateForm = () => {
        let isValid = true;

        setRatingError('');
        setCommentError('');

        if (rating === 0) {
            setRatingError('Please select a rating');
            isValid = false;
        }

        if (comment.trim() === '') {
            setCommentError('Please enter a review comment');
            isValid = false;
        }

        return isValid;
    };
    const handleCommentChange = (e) => {
        const text = e.target.value;
        if (text.length <= maxChars) {
            setComment(text);
            setCharCount(text.length);
            setCommentError('');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {

            setIsLoading(true)
            paymentMethodActions.createFeedBackAdmin({
                "rating": rating,
                "feedbackText": comment,
                "payment_action_key": storData?.payment_action_key
            }).then((res) => {
                dispatch(alertActions.success(res?.message))
                console.log(res)
            }).catch((error) => {
                dispatch(alertActions.error(error))
            }).finally(() => {
                setRating(0);
                setComment('');
                setCharCount(0);
                onClose();
                setIsLoading(false)
            })
        }

    };

    const ErrorMessage = ({ message }) => {
        if (!message) return null;

        return (
            <div className="flex items-center text-red-500 mt-1 mb-2 text-sm">
                <BiErrorCircle className="mr-1" />
                <span>{message}</span>
            </div>
        );
    };

    return (
        <>
            <Loader loading={isLoading} />
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm">
                <div className="bg-white p-6 rounded-[19px] shadow-lg text-center lg:w-[600px] w-11/12 mx-auto">

                    <div className='flex justify-between items-center'>
                        <p className='font-bold text-black text-lg'>
                            {modalType === 'view' ? 'Reviews' : 'Post a Review'}
                        </p>
                        <div className='bg-[#15A14A26] rounded-full flex justify-center items-center h-7 w-7 text-[#15A14A] cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-700 blur-none'>
                            <MdOutlineClose
                                size={20}
                                className=' cursor-pointer'
                                onClick={onClose}
                                title='Close'
                            />
                        </div>
                    </div>

                    {modalType === 'view' ? (
                        <div className="p-4 overflow-y-auto max-h-[70vh] space-y-3">
                            {reviewData && reviewData.length > 0 ? reviewData?.map(review => (
                                <>
                                    <div className="p-3 border rounded-md border-gray-200">
                                        <div className="flex justify-start items-center gap-3 mb-2">
                                            <img
                                                src={review.userId?.profile}
                                                alt={review.name}
                                                className="w-10 h-10 rounded-full"
                                                onError={(e) => {
                                                    e.target.onerror = null; // prevent infinite loop
                                                    e.target.src = "/Rectangle 1614423849.png"; // fallback image path
                                                }}
                                            />

                                            <div>
                                                <h4 className="font-medium text-gray-800 capitalize text-start">{review?.userId?.userName}</h4>
                                                <div className="flex items-center">
                                                    <StarRating rating={review.rating} />
                                                    <span className="ml-1 text-xs text-gray-600">{review.rating}/5</span>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="text-sm text-gray-600 text-start">{review.feedbackText}</p>
                                    </div>
                                </>
                            )) : <><Nodata message="No review available" /></>}
                        </div>
                    ) : (
                        <div className="p-4">
                            <div className="mb-4 flex items-center">
                                <img
                                    src={storData?.storeId?.storeLogo || "https://via.placeholder.com/40"}
                                    alt="User Avatar"
                                    className="w-10 h-10 rounded-full mr-3"
                                />
                                <div>
                                    <p className="font-medium text-gray-800 capitalize">{storData?.storeId?.storeName}</p>
                                    <p className="text-xs text-gray-500">Posting publicly</p>
                                </div>
                            </div>

                            <div className="mb-4">
                                <StarRating rating={rating} setRating={setRating} editable={true} error={!!ratingError} />
                                <ErrorMessage message={ratingError} />
                            </div>

                            <form onSubmit={handleSubmit}>
                                <textarea
                                    className="w-full border border-gray-300 rounded-md p-3 h-32 resize-none mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English."
                                    value={comment}
                                    onChange={handleCommentChange}
                                ></textarea>
                                <ErrorMessage message={commentError} />

                                <div className="flex justify-end mb-4">
                                    <span className="text-xs text-gray-500">{charCount}/{maxChars}</span>
                                </div>

                                <Button type="submit">Post A Review</Button>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ReviewModal;